import React, { useCallback, useContext, useEffect, useMemo } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Select from "../../../../components/basics/SelectErp";

import { HeaderModal } from "../styles/Emissao";
import TextField from "../../../../components/basics/TextFieldErp";

import { EmissaoContext } from "../contexts/EmissaoContext";
import useEmissaoController from "../controllers/EmissaoController";
import moment from "moment";

const ModalEmissaoFormaPagto = ({
  modalFormaPagtoOpen,
  setModalFormaPagtoOpen,
  indexPayment,
}) => {
  const {
    paymentValue,
    setPaymentValue,
    nfeListPaymentMethod,
    nfeListPaymentIndicator,
    nfeListPaymentTypeIntegration,
    nfeListBandeiras,
    nfeListOperadoras,
    pagtoTableFormaPagto,
    itensTable,
    itensTotalNfe,
    additionalPaymentsInfo,
    pagtoTableCobranca,
    headerDateJL,
  } = useContext(EmissaoContext);

  const {
    paymentMethod,
    setPaymentMethod,
    paymentIndicator,
    setPaymentIndicator,
    paymentTransshipment,
    setPaymentTransshipment,
    handleAddPayment,
    paymentTypeIntegration,
    setPaymentTypeIntegration,
    paymentFlag,
    setPaymentFlag,
    paymentCnpj,
    setPaymentCnpj,
    paymentError,
    paymentCodeCard,
    setPaymentCodeCard,
    handleEditPayment,
    handleCalcPaymentTable,
    setPaymentOperator,
    paymentOperator,
    handlePaymentOperatorByFlag,
    refreshOperatorCnpj,
    setRefreshOperatorCnpj,
  } = useEmissaoController();

  const someDateAfter = useMemo(
    () =>
      pagtoTableCobranca.some((charge) =>
        moment(charge?.cobrancaDtVenctoValue).isAfter(moment(headerDateJL))
      ),
    [headerDateJL, pagtoTableCobranca]
  );

  const handleClose = () => {
    setModalFormaPagtoOpen(false);
  };

  const handleSetPaymentMethod = useCallback(
    (value) => {
      setPaymentMethod(value);

      if (additionalPaymentsInfo.includes(value?.value)) {
        setPaymentTypeIntegration(nfeListPaymentTypeIntegration[1]);
      }
    },
    [
      nfeListPaymentTypeIntegration,
      setPaymentMethod,
      setPaymentTypeIntegration,
      additionalPaymentsInfo,
    ]
  );

  const handleFilterPaymentIndicatorOptions = useCallback(
    (option) => {
      if (pagtoTableCobranca?.length) {
        if (someDateAfter) {
          return option.value === "1";
        }
      }

      return true;
    },
    [pagtoTableCobranca?.length, someDateAfter]
  );

  useEffect(() => {
    if (indexPayment !== null) {
      handleEditPayment(indexPayment);
    }
    // eslint-disable-next-line
  }, [itensTotalNfe, pagtoTableFormaPagto, itensTable, indexPayment]);

  useEffect(() => {
    if (paymentMethod?.value === "90") {
      setPaymentValue("0,00");
    } else {
      handleCalcPaymentTable(indexPayment);
    }
    // eslint-disable-next-line
  }, [pagtoTableFormaPagto, itensTable, paymentMethod]);

  useEffect(() => {
    handlePaymentOperatorByFlag({ paymentFlag, indexPayment, paymentMethod });
  }, [handlePaymentOperatorByFlag, paymentFlag, indexPayment, paymentMethod]);

  useEffect(() => {
    if (refreshOperatorCnpj) {
      if (paymentOperator) setPaymentCnpj(paymentOperator.sn_cnpj);
      else setPaymentCnpj("");
    }
  }, [setPaymentCnpj, paymentOperator, refreshOperatorCnpj]);

  useEffect(() => {
    if (someDateAfter && !indexPayment) {
      setPaymentIndicator(
        nfeListPaymentIndicator.find((option) => option.value === "1")
      );
    }
  }, [
    someDateAfter,
    indexPayment,
    nfeListPaymentIndicator,
    setPaymentIndicator,
  ]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={modalFormaPagtoOpen}
      onClose={handleClose}
      aria-labelledby="dialog-forma-pagto"
    >
      <HeaderModal>
        <DialogTitle id="dialog-forma-pagto">
          <Chip
            label="FORMA DE PAGAMENTO"
            bgcolor="primary"
            textcolor="white"
          />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container>
          <Grid container spacing={2}>
            <Grid item sm={4}>
              <Select
                descriptionField="label"
                label="Forma de Pagamento"
                optionsList={nfeListPaymentMethod}
                value={paymentMethod}
                onChange={handleSetPaymentMethod}
                error={paymentError.paymentMethod ? true : false}
                helperText={paymentError.paymentMethod || ""}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                value={paymentValue}
                setValue={setPaymentValue}
                size="small"
                label="Valor"
                mask="decimal"
                error={paymentError.paymentValue ? true : false}
                helperText={paymentError.paymentValue || ""}
                disabled={paymentMethod?.value === "90"}
              />
            </Grid>
            <Grid item sm={4}>
              <Select
                value={paymentIndicator}
                setValue={setPaymentIndicator}
                descriptionField="label"
                label="Indicador"
                optionsList={nfeListPaymentIndicator.filter(
                  handleFilterPaymentIndicatorOptions
                )}
              />
            </Grid>
            {paymentMethod?.value !== "90" && (
              <Grid item sm={2}>
                <TextField
                  value={paymentTransshipment}
                  setValue={setPaymentTransshipment}
                  size="small"
                  label="Troco"
                  mask="decimal"
                />
              </Grid>
            )}

            {additionalPaymentsInfo.includes(paymentMethod?.value) ? (
              <>
                <Grid item sm={7}>
                  <Select
                    value={paymentTypeIntegration}
                    setValue={setPaymentTypeIntegration}
                    descriptionField="label"
                    label="Tipo de Integração para Pagamento"
                    optionsList={nfeListPaymentTypeIntegration}
                  />
                </Grid>
                <Grid item sm={5}>
                  <Select
                    value={paymentFlag}
                    setValue={setPaymentFlag}
                    descriptionField="sn_descricao"
                    label="Bandeira"
                    optionsList={nfeListBandeiras}
                  />
                </Grid>
                <Grid item sm={7}>
                  <Select
                    value={paymentOperator}
                    setValue={setPaymentOperator}
                    descriptionField="sn_descricao"
                    label="Instituição de Pagamento"
                    optionsList={nfeListOperadoras}
                  />
                </Grid>
                <Grid item sm={5}>
                  <TextField
                    value={paymentCnpj}
                    setValue={setPaymentCnpj}
                    size="small"
                    label="CNPJ da Instituição de Pagamento"
                  />
                </Grid>
                <Grid item sm={12}>
                  <TextField
                    value={paymentCodeCard}
                    setValue={setPaymentCodeCard}
                    size="small"
                    label="Código de Autorização do Cartão"
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    label="Atualizar CNPJ da Instituição automaticamente?"
                    value="end"
                    labelPlacement="start"
                    control={
                      <Switch
                        checked={refreshOperatorCnpj}
                        onChange={() => {
                          setRefreshOperatorCnpj((current) => !current);
                        }}
                        color="primary"
                      />
                    }
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          onClick={() => handleAddPayment(setModalFormaPagtoOpen, indexPayment)}
          label="incluir"
        />
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalEmissaoFormaPagto;
